export const CHAR_VALUES = [
  'Q',
  'W',
  'E',
  'R',
  'T',
  'Y',
  'U',
  'I',
  'O',
  'P',
  'A',
  'S',
  'D',
  'F',
  'G',
  'H',
  'J',
  'K',
  'L',
  'Z',
  'X',
  'C',
  'V',
  'B',
  'N',
  'M',
  'Ö',
  'Ü',
  'Ó',
  'Ő',
  'Ú',
  'É',
  'Á',
  'Ű',
  'Í',
  'CS',
  'DZ',
  'DZS',
  'GY',
  'LY',
  'NY',
  'SZ',
  'TY',
  'ZS',
] as const
